import { StatementEditorV2ContentDataType, StatementEditorV2FieldDefinition } from '../types'
import { ItemHeaderLayoutV2 } from './ItemHeaderLayoutV2'
import { ContentBlockActions } from './ContentBlockActions'
import { RenderCellV2 } from '../../DataTableV2/RenderCellV2'

export function StatementV2({
  item,
  headerFields,
  contentFields,
  field,
  parentId,
  serverActionsDisabled = false,
}: {
  item: StatementEditorV2ContentDataType
  headerFields?: StatementEditorV2FieldDefinition[]
  contentFields?: StatementEditorV2FieldDefinition[]
  field: StatementEditorV2FieldDefinition
  parentId: string
  serverActionsDisabled?: boolean
}) {
  const actions = field.actions ?? []

  const renderContentField = (f: StatementEditorV2FieldDefinition) => {
    const fieldValue = item[f.propertyId]
    if (fieldValue === undefined || fieldValue === null) return null

    if (f.layout.dataDisplay) {
      return (
        <div key={f.propertyId}>
          <RenderCellV2 dataDisplay={f.layout.dataDisplay} value={fieldValue} />
        </div>
      )
    }

    return (
      <div key={f.propertyId}>
        <span className="whitespace-pre-wrap">{String(fieldValue)}</span>
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col gap-y-5 rounded-lg bg-background shadow">
      <div className="bg-offwhite/50 flex justify-end gap-x-2 border-b">
        {headerFields && headerFields.length > 0 && <ItemHeaderLayoutV2 headerFields={headerFields} content={item} />}
        <ContentBlockActions actions={actions} formData={item} serverActionsDisabled={serverActionsDisabled} />
      </div>
      <div className="flex flex-col gap-y-2 px-5 pb-5">{contentFields?.map(renderContentField)}</div>
    </div>
  )
}
